module.exports = __webpack_public_path__ + "static/media/systemInactive.da42f813.svg";